import { useState } from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import SideItems from 'src/components/ui/SideItems';
import ActionPlate from 'src/components/ui/ActionPlate';
import RouterLink from 'src/components/ui/RouterLink';

const SideNode = ({
	label,
	labelGroup,
	labelGroupTo,
	items = [],
	isCollapsedProp,
	isCollapsedDefault,
	onCollapse,
}) => {
	const [isCollapsedState, setCollapsed] = useState(isCollapsedDefault);
	const isCollapsed =
		isCollapsedProp === undefined ? isCollapsedState : isCollapsedProp;
	const handleClickCollapse = () => {
		setCollapsed(!isCollapsed);
		if (onCollapse) onCollapse(!isCollapsed);
	};

	const node = (
		<Stack spacing={1}>
			{Boolean(items.length) &&
				items.map(({ plate, data, dataExtra, id }) => (
					<ActionPlate
						cardContent={{ sx: { p: 2 } }}
						collapseNode={dataExtra && <SideItems {...dataExtra} />}
						{...plate}
						key={id}
					>
						<SideItems {...data} />
					</ActionPlate>
				))}
		</Stack>
	);

	if (labelGroup) {
		return (
			<Stack spacing={1}>
				<Stack
					alignItems="center"
					direction="row"
					spacing={1}
					sx={{ alignSelf: 'start' }}
				>
					<Typography
						component={Stack}
						variant={isCollapsed && 'subtitle1'}
						alignItems="center"
						direction="row"
						onClick={handleClickCollapse}
						sx={{ cursor: 'pointer' }}
					>
						<KeyboardArrowRightIcon
							color={isCollapsed ? '' : 'secondary'}
							sx={{ transform: isCollapsed && 'rotate(90deg)' }}
						/>
						{labelGroup}
					</Typography>
					{labelGroupTo && (
						<Link
							component={RouterLink}
							to={labelGroupTo}
							underline="hover"
							variant="body2"
							color="primary"
							sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}
						>
							Перейти
						</Link>
					)}
				</Stack>

				<Collapse in={isCollapsed} timeout="auto" unmountOnExit>
					{node}
				</Collapse>
			</Stack>
		);
	}

	return (
		<Stack spacing={1}>
			{label && <Typography color="secondary">{label}</Typography>}

			{node}
		</Stack>
	);
};

SideNode.propTypes = {
	label: PropTypes.string,
	labelGroup: PropTypes.string,
	labelGroupTo: PropTypes.string,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			plate: PropTypes.shape(ActionPlate.propTypes),
			data: PropTypes.shape(SideItems.propTypes),
			dataExtra: PropTypes.shape(SideItems.propTypes),
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		}),
	),
	isCollapsedProp: PropTypes.bool,
	isCollapsedDefault: PropTypes.bool,
	onCollapse: PropTypes.func,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SideNode;
